import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_BodyBasic.vue?vue&type=template&id=144e01e2&scoped=true&"
import script from "./c_Creator_EditQuests_Item_BodyBasic.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_BodyBasic.vue?vue&type=script&lang=js&"
import style0 from "./c_Creator_EditQuests_Item_BodyBasic.vue?vue&type=style&index=0&id=144e01e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e01e2",
  null
  
)

export default component.exports